import { render, staticRenderFns } from "./TypeOfUserPage.vue?vue&type=template&id=7fc9ac5a&"
import script from "./TypeOfUserPage.vue?vue&type=script&lang=js&"
export * from "./TypeOfUserPage.vue?vue&type=script&lang=js&"
import style0 from "./TypeOfUserPage.vue?vue&type=style&index=0&id=7fc9ac5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports